import React from 'react';
// import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';

import { ModalWithStyles } from './ModalWithStyles';
import { Formik } from 'formik';
// import { useRecoilState } from 'recoil';
// import { replaceAgentForm } from '../../../recoil/atoms/replaceAgentForm';

export function ReplaceAgentModal({
  handleClose,
  show,
  oldAgentName,
  newAgentName,
  handleSubmit,
  setFlagForReplace,
  // fname,
  // lname,
  // email,
  // calleridNumber,
  // calleridName,
  // smsNumber,
}) {
  // const [, setReplaceAgent] = useRecoilState(replaceAgentForm);
  return (
    <Formik
      onSubmit={async (values, actions) => {
        setFlagForReplace(true);
        handleSubmit();
        handleClose();
      }}
      enableReinitialize={true}
      initialValues={{
        random: '',
      }}
    >
      {(formik) => (
        <ModalWithStyles
          onSubmit={formik.handleSubmit}
          title={`Replace Agent ${oldAgentName}`}
          show={show}
          onHide={handleClose}
          isSubmitting={formik.isSubmitting}
          isLoading={formik.isSubmitting}
        >
          <p>
            You are about to replace the Agent <b> {oldAgentName}</b> with the
            new agent <b>{newAgentName}</b>, this procedure is not reversible.
          </p>
          <p>Do you want to proceed?</p>
        </ModalWithStyles>
      )}
    </Formik>
  );
}
